/* RB Poster · «Completa tu pared»: gancho, wallpaper y set con casilla en la ficha. Marcado en snippets/rb-extras.liquid.
   Lo que el cliente marca viaja EN LA MISMA petición que el póster: el tema monta su envío con new FormData(form) y ese momento
   lanza el evento «formdata»; aquí se reescribe ese envío de «id=…» a «items[0]…, items[1]…». No se intercepta el botón ni el
   envío: quien valida antes (UploadKit), quien pulsa el botón por su cuenta (la barra fija, «Verlo en mi pared») y quien escucha
   después (cajón, regalo Mystery, analítica de Shopify) siguen igual.
   Red de seguridad: si el envío lleva un archivo (póster personalizado) o el navegador no lanza «formdata» (Safari < 15), los
   extras se añaden después, en UNA sola petición, al oír «variant:add». Y un extra nunca bloquea la compra del póster: si
   Shopify rechaza el envío con extras, se repite una vez sin ellos (y se le dice al cliente qué no ha entrado).
   No hay botón propio: se compra con el de arriba, que enseña el total (también la barra fija). La suma de lo marcado se
   publica en window.rbExtrasSuma y en el evento «rb:extras:total» para la barra del regalo.
   Marcado que espera: <div data-rbe data-form="id del formulario"> … <input type="checkbox" data-rbe-id="variante[,variante]"
   data-rbe-q="1" data-rbe-clave="gancho|wallpaper|set" data-rbe-precio="céntimos" data-rbe-antes="céntimos"> … </div> */
(function () {
  if (window.__rbExtras) return; window.__rbExtras = true;                     // una sola vez por página
  var d = document, html = d.documentElement;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  // El id se lee con getAttribute: el formulario tiene un campo que se llama «id» y tapa la propiedad.
  function idDe(f) { return (f && f.getAttribute && f.getAttribute('id')) || ''; }
  function esFicha(f) { return idDe(f).indexOf('product-form-main-') === 0; }
  function cajas(f) { return $$('[data-rbe][data-form="' + idDe(f) + '"]'); }
  function formDe(c) { return d.getElementById(c.getAttribute('data-form')); }
  function entero(el, a) { return parseInt(el.getAttribute(a), 10) || 0; }

  /* ——— En un tema sin publicar, «?rbup=app» enseña el bloque de la app en vez de este, para comparar (se recuerda en la visita) ——— */
  if ($('[data-rbe][data-prueba]')) {
    try {
      var q = new URLSearchParams(location.search).get('rbup');
      if (q != null) sessionStorage.setItem('rbup', q);
      if ((q != null ? q : sessionStorage.getItem('rbup')) === 'app') html.setAttribute('data-rbup', 'app');
    } catch (e) {}
  }

  /* ——— El dinero, con el formato del país del cliente: se saca de una muestra que pinta Liquid (1.234,56) ——— */
  function hazDinero(muestra) {
    var m = /^(.*?)1(\D?)23[45](?:(\D)(56))?(.*)$/.exec(muestra || '');                  // «1.235 Ft»: moneda sin decimales (redondea)
    if (!m) return function (c) { return (c / 100).toFixed(2) + ' ' + ((window.Shopify && Shopify.currency && Shopify.currency.active) || ''); };
    return function (c) {
      var v = (c / 100).toFixed(m[4] ? 2 : 0).split('.'); v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
      return m[1] + v[0] + (m[4] ? m[3] + v[1] : '') + m[5];
    };
  }
  function dineroDe(c) { return c.__din || (c.__din = hazDinero(c.getAttribute('data-muestra'))); }

  /* ——— Lo marcado: una entrada por fila (para el total) y una línea de cesta por variante (el set son dos) ——— */
  function marcados(f) {
    var out = [];
    cajas(f).forEach(function (c) {
      $$('input[data-rbe-id]:checked', c).forEach(function (x) {
        var ids = (x.getAttribute('data-rbe-id') || '').split(',').filter(Boolean), fila = x.closest('.rbe__fila');
        if (!ids.length || x.disabled || (fila && fila.hidden) || c.hidden) return;
        out.push({ ids: ids, q: Math.max(1, entero(x, 'data-rbe-q')), clave: x.getAttribute('data-rbe-clave') || 'extra', precio: entero(x, 'data-rbe-precio'), marca: x.getAttribute('data-rbe-marca') || '', campo: x });
      });
    });
    return out;
  }
  // En la cesta sale arriba lo último que entra: el póster va el último del envío y, antes, el set, el gancho y el wallpaper.
  var ORDEN = { wallpaper: 1, gancho: 2, set: 3 };
  function lineas(filas) {
    var out = [];
    filas.slice().sort(function (a, b) { return (ORDEN[a.clave] || 0) - (ORDEN[b.clave] || 0); }).forEach(function (x) {
      x.ids.forEach(function (id) { var p = { _extra: x.clave }; if (x.marca) p._set = x.marca; out.push({ id: String(id), q: x.q, props: p, campo: x.campo }); });
    });
    return out;
  }
  function desmarca(campo) { if (!campo.checked) return; campo.checked = false; campo.dispatchEvent(new Event('change', { bubbles: true })); }

  /* ——— 1. La misma petición ——— */
  d.addEventListener('formdata', function (e) {
    var f = e.target, fd = e.formData; if (!fd || !esFicha(f)) return;
    f.__rbeIdas = null; f.__rbePend = null; f.__rbeVisto = 1;
    f.__rbeReintento = f.__rbeReintento === 1 ? 2 : 0;                         // 2: este envío ES el reintento; 0: lo ha pulsado el cliente
    var extras = lineas(marcados(f)), id = fd.get('id'); if (!extras.length || !id) return;
    var conArchivo = false, claves = [];
    fd.forEach(function (v, k) { if (typeof v !== 'string') conArchivo = true; if (claves.indexOf(k) < 0) claves.push(k); });
    if (conArchivo) { f.__rbePend = extras; return; }                          // la foto del cliente no se toca: los extras, después (los de AHORA)
    extras.forEach(function (x, i) {
      var p = 'items[' + i + ']';
      fd.append(p + '[id]', x.id); fd.append(p + '[quantity]', String(x.q));
      for (var k in x.props) fd.append(p + '[properties][' + k + ']', x.props[k]);
    });
    var yo = 'items[' + extras.length + ']';
    fd.append(yo + '[id]', id);
    fd.append(yo + '[quantity]', fd.get('quantity') || '1');
    var marcaSet = ''; extras.forEach(function (x) { if (x.props._set) marcaSet = x.props._set; });
    if (marcaSet) fd.append(yo + '[properties][_set]', marcaSet);              // con el set, las tres láminas llevan la misma marca (como en la página de sets)
    claves.forEach(function (k) {
      if (k.indexOf('properties[') === 0) { fd.getAll(k).forEach(function (v) { fd.append(yo + '[properties]' + k.slice(10), v); }); fd.delete(k); }
      else if (k === 'selling_plan') { fd.append(yo + '[selling_plan]', fd.get(k)); fd.delete(k); }
    });
    fd.delete('id'); fd.delete('quantity');
    f.__rbeIdas = extras;                                                      // por si Shopify rechaza el envío (ver 3)
  });

  /* ——— 2. Lo que no haya viajado, después y de una vez ——— */
  d.addEventListener('variant:add', function (e) {
    var f = e.target; if (!esFicha(f)) return;
    var idas = f.__rbeIdas, faltan = f.__rbePend, visto = f.__rbeVisto, quitados = f.__rbeQuitados;
    f.__rbeIdas = f.__rbePend = f.__rbeQuitados = null; f.__rbeVisto = 0; f.__rbeReintento = 0;
    if (quitados) avisa(f, quitados);                                          // el póster entró sin ellos: se dice
    if (idas) { idas.forEach(function (x) { desmarca(x.campo); }); return; }   // viajaron con el póster: lo marcado DESPUÉS no se añade solo
    if (!faltan && !visto) faltan = lineas(marcados(f));                       // navegador sin «formdata»: lo marcado
    if (!faltan || !faltan.length) return;
    var secciones = [];
    html.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: secciones } }));
    fetch(raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify({ items: faltan.map(function (x) { return { id: +x.id, quantity: x.q, properties: x.props }; }), sections: secciones.join(',') }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        return fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cesta) {
          cesta.sections = j.sections;
          // «cart:change» SIEMPRE con la cesta dentro (el tema lee detail.cart.item_count). El cajón ya está abierto: no se pide que se abra otra vez.
          html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'rb:extras', cart: cesta } }));
          faltan.forEach(function (x) { desmarca(x.campo); });
        });
      })
      .catch(function () { avisa(f, faltan); faltan.forEach(function (x) { desmarca(x.campo); }); d.dispatchEvent(new CustomEvent('cart:refresh')); });
  });

  /* ——— 3. Si Shopify rechaza el envío con extras, se repite una vez solo con el póster ——— */
  d.addEventListener('cart:error', function (e) {
    var f = e.target; if (!esFicha(f)) return;
    if (f.__rbeIdas && !f.__rbeReintento) {
      e.stopPropagation();                                                     // sin el aviso rojo del tema: se va a reintentar (si el reintento falla, ese aviso sí sale)
      f.__rbeQuitados = f.__rbeIdas; f.__rbeIdas = null; f.__rbeReintento = 1;
      f.__rbeQuitados.forEach(function (x) { desmarca(x.campo); });
      var b = botonDe(f);
      if (b && !b.disabled) setTimeout(function () { b.click(); }, 400);       // con margen: un 429 no se arregla repitiendo a los 20 ms
      return;
    }
    if (f.__rbeQuitados) {                                                     // falló también solo: se devuelve lo que el cliente había marcado
      f.__rbeQuitados.forEach(function (x) { if (!x.campo.checked && !x.campo.disabled) { x.campo.checked = true; x.campo.dispatchEvent(new Event('change', { bubbles: true })); } });
      f.__rbeQuitados = null;
    }
    f.__rbeReintento = 0;
  }, true);
  // Lo que no ha podido entrar se dice (texto de Liquid en data-aviso, con [N] para los nombres); sin ese hueco en el marcado no hace nada.
  function avisa(f, lineasQuitadas) {
    cajas(f).forEach(function (c) {
      var p = $('[data-rbe-aviso]', c); if (!p) return;
      var nombres = []; lineasQuitadas.forEach(function (x) { var fila = x.campo.closest('.rbe__fila'), n = fila && $('.rbe__n', fila), t = fila && fila.getAttribute('data-rbe-nombres') || (n ? n.textContent.trim() : ''); if (t && nombres.indexOf(t) < 0) nombres.push(t); });
      p.textContent = (p.getAttribute('data-aviso') || '[N]').replace('[N]', function () { return nombres.join(', '); }); p.hidden = false;
      setTimeout(function () { p.hidden = true; }, 8000);
    });
  }

  /* ——— 4. El total: en el botón de compra de arriba y en la barra fija (no hay más botones: se compra con el de siempre) ——— */
  function botonDe(f) { return $('buy-buttons[form="' + idDe(f) + '"] button[type="submit"]'); }
  function base(f) {
    if (f.__rbeBase == null) { var c = cajas(f)[0]; f.__rbeBase = c ? entero(c, 'data-base') : 0; }
    return f.__rbeBase;
  }
  function pintaTotal(f) {
    var cs = cajas(f); if (!cs.length) return;
    var extra = marcados(f).reduce(function (s, x) { return s + x.precio * x.q; }, 0), din = dineroDe(cs[0]), id = idDe(f), total = din(base(f) + extra);
    $$('buy-buttons[form="' + id + '"] .atc-price').forEach(function (b) {
      if (!b.hasAttribute('data-rbe-solo')) b.setAttribute('data-rbe-solo', b.textContent);
      b.textContent = extra ? total : b.getAttribute('data-rbe-solo');
    });
    // la barra fija no lleva el importe en su botón: con extras marcados se le pone el total, para que nadie compre a ciegas
    $$('product-sticky-bar[form="' + id + '"] button[type="submit"]').forEach(function (b) {
      var t = $('[data-rbe-fija]', b);
      if (!extra) { if (t) t.parentNode.removeChild(t); return; }
      if (!t) { t = d.createElement('span'); t.setAttribute('data-rbe-fija', ''); b.appendChild(t); }
      t.textContent = ' \u2022 ' + total;
    });
    if (f.__rbeSuma !== extra) { f.__rbeSuma = extra; window.rbExtrasSuma = extra; d.dispatchEvent(new CustomEvent('rb:extras:total', { detail: { extra: extra, total: base(f) + extra } })); }
  }
  function pintaImporte(el, ahora, antes, din) {                               // «€5,90» y, si lo hay, el precio anterior tachado
    if (!el) return;
    el.textContent = ''; var b = d.createElement('b'); b.textContent = din(ahora); el.appendChild(b);
    var rebaja = antes > ahora; el.classList.toggle('rbe__p--rebaja', rebaja);
    if (rebaja) { var s = d.createElement('s'); s.textContent = din(antes); el.appendChild(s); }
  }

  /* ——— 5. Lo que depende de la variante elegida ——— */
  // El gancho: solo con marco, y dos en los tamaños grandes.
  function ponGancho(c, o2, o3) {
    var fila = $('[data-rbe-fila="gancho"]', c); if (!fila) return;
    var campo = $('input', fila), con = o3 !== c.getAttribute('data-sin'), q = (c.getAttribute('data-dobles') || '').split('|').indexOf(o2) >= 0 ? 2 : 1;
    fila.hidden = !con; if (!con) { campo.checked = false; fila.classList.remove('is-on'); }
    campo.setAttribute('data-rbe-q', q);
    $$('[data-rbe-uno]', fila).forEach(function (t) { t.textContent = t.getAttribute(q === 2 ? 'data-rbe-dos' : 'data-rbe-uno'); });
    pintaImporte($('[data-rbe-importe]', fila), entero(campo, 'data-rbe-precio') * q, entero(campo, 'data-rbe-antes') * q, dineroDe(c));
  }
  // El set: dos pósters a juego en la MISMA variante que se elige arriba. Liquid deja hasta cuatro compañeros en orden
  // (id de producto, título, variantes «estilo|tamaño|marco» → [id, precio, precio anterior, disponible] y la foto de cada
  // «estilo|marco»). Aquí se decide a quién ofrecer: los dos primeros que no estén ya en la cesta y tengan esa variante; con
  // uno de ellos en la cesta, solo el que falta (el set son tres). Y se ponen al día casilla, precio, título, texto
  // («30x40cm / Marco negro») y miniaturas (con su marco o, sin marco, solo la lámina). Si no queda nadie, la fila no sale.
  function pon(patron, A, B) { return String(patron || '').replace('[A]', function () { return A; }).replace('[B]', function () { return B; }); }
  function ponSet(c, o) {
    var fila = $('[data-rbe-fila="set"]', c), datos = $('[data-rbe-set-datos]', c);
    if (!fila) return;
    var campo = $('input', fila), j = null; try { j = datos && JSON.parse(datos.textContent); } catch (e) {}
    var lista = (j && j.c) || [], cesta = c.getAttribute('data-cesta') || '', k = o.join('|'), conMarco = o[2] !== c.getAttribute('data-sin');
    var dentro = 0, libres = [];
    lista.forEach(function (x) {
      if (cesta.indexOf(',' + x.id + ',') >= 0) { dentro++; return; }
      var v = x.v && x.v[k]; if (v && v[3]) libres.push({ p: x, v: v });
    });
    var eleg = libres.slice(0, dentro === 1 ? 1 : 2);
    if (!eleg.length) { campo.checked = false; campo.setAttribute('data-rbe-id', ''); fila.classList.remove('is-on'); fila.hidden = true; return; }
    var precio = 0, antes = 0, rebaja = true;
    eleg.forEach(function (x) { precio += x.v[1]; antes += x.v[2]; if (!(x.v[2] > x.v[1])) rebaja = false; });
    campo.setAttribute('data-rbe-id', eleg.map(function (x) { return x.v[0]; }).join(','));
    campo.setAttribute('data-rbe-precio', precio); campo.setAttribute('data-rbe-antes', rebaja ? antes : 0);
    fila.setAttribute('data-rbe-nombres', eleg.map(function (x) { return x.p.t; }).join(', '));
    var n = $('[data-rbe-set-n]', fila);
    if (n) n.textContent = eleg.length === 2 ? pon(n.getAttribute('data-dos'), eleg[0].p.t, eleg[1].p.t) : pon(n.getAttribute('data-uno'), eleg[0].p.t, '');
    var txt = $('[data-rbe-variante]', fila);
    if (txt) txt.textContent = o[1] + ' / ' + (conMarco ? String(txt.getAttribute('data-rbe-marco-txt') || '[M]').replace('[m]', function () { return String(o[2]).toLowerCase(); }).replace('[M]', function () { return o[2]; }) : o[2]);
    $$('[data-rbe-arte]', fila).forEach(function (s, i) {
      var e = eleg[i], im = $('img', s); s.hidden = !e; if (!e) return;
      var u = e.p.i && e.p.i[o[0] + '|' + o[2]];
      cambiaFoto(s, im, u, conMarco);
    });
    pintaImporte($('[data-rbe-importe]', fila), precio, rebaja ? antes : 0, dineroDe(c));
    fila.classList.toggle('is-on', campo.checked); fila.hidden = false;
  }
  // La miniatura no se cambia hasta que la nueva está cargada, y el recorte (con o sin marco) cambia con ella: sin parpadeo.
  function cambiaFoto(s, im, u, conMarco) {
    if (!u || !im || im.getAttribute('src') === u) { s.__rbeU = u || ''; s.classList.toggle('is-marco', conMarco); return; }
    s.__rbeU = u;
    var t = new Image(), hecho = false, aplica = function () { if (hecho || s.__rbeU !== u) return; hecho = true; im.setAttribute('src', u); s.classList.toggle('is-marco', conMarco); };
    t.onload = aplica; t.onerror = aplica; t.src = u;
    if (t.complete) aplica(); else setTimeout(aplica, 1500);                         // si la red va mal, se cambia igualmente
  }
  // Las fotos de los otros marcos de los pósters que se ofrecen, pedidas cuando el bloque está cerca: elegir marco las cambia al momento.
  function precarga(c) {
    if (c.__rbePre) return; c.__rbePre = true;
    var datos = $('[data-rbe-set-datos]', c), j = null; try { j = datos && JSON.parse(datos.textContent); } catch (e) {}
    var vistos = {}, n = 0;
    ((j && j.c) || []).slice(0, 3).forEach(function (x) { for (var k in (x.i || {})) { var u = x.i[k]; if (u && !vistos[u] && n < 12) { vistos[u] = 1; n++; (new Image()).src = u; } } });
  }
  function vigila(c) {
    if (c.__rbeVig || !$('[data-rbe-set-datos]', c)) return; c.__rbeVig = true;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); precarga(c); } }); }, { rootMargin: '700px 0px' });
    io.observe(c);
  }
  function ajustaHueco(c) {                                                    // sin filas a la vista, el bloque entero se recoge
    var hay = $$('.rbe__fila', c).some(function (x) { return !x.hidden; });
    c.hidden = !hay;
    var hueco = c.parentNode; if (hueco && hueco.classList && hueco.classList.contains('product-info__block-item')) hueco.style.display = hay ? '' : 'none';
  }

  d.addEventListener('change', function (e) {
    var x = e.target; if (!x || !x.matches || !x.matches('input[data-rbe-id]')) return;
    var c = x.closest('[data-rbe]'), fila = x.closest('.rbe__fila'); if (fila) fila.classList.toggle('is-on', x.checked);
    var f = c && formDe(c); if (f) pintaTotal(f);
  });
  d.addEventListener('variant:change', function (e) {
    var f = e.target, v = e.detail && e.detail.variant; if (!esFicha(f) || !v) return;
    f.__rbeBase = v.price;
    cajas(f).forEach(function (c) {
      c.setAttribute('data-o1', v.option1 || ''); c.setAttribute('data-o2', v.option2 || ''); c.setAttribute('data-o3', v.option3 || '');
      ponGancho(c, v.option2, v.option3); ponSet(c, [v.option1, v.option2, v.option3]); ajustaHueco(c);
    });
    setTimeout(function () { pintaTotal(f); }, 0);                             // después de que el tema cambie el botón
  });

  // Tras añadir a la cesta la página no se recarga: se apunta lo que hay dentro para no ofrecer un set con algo repetido.
  d.addEventListener('cart:change', function (e) {
    var cesta = e.detail && e.detail.cart; if (!cesta || !cesta.items) return;
    ponCesta(',' + cesta.items.map(function (i) { return i.product_id; }).join(',') + ',');
  });

  function arranca() {
    $$('[data-rbe]').forEach(function (c) {
      // el set, según lo que haya en la cesta (Liquid pinta los dos primeros; aquí se cambian por los suplentes si hace falta)
      ponSet(c, [c.getAttribute('data-o1'), c.getAttribute('data-o2'), c.getAttribute('data-o3')]); ajustaHueco(c);
      // el navegador puede devolver casillas marcadas al volver atrás: el borde y el total se ponen al día
      $$('input[data-rbe-id]', c).forEach(function (x) { var fila = x.closest('.rbe__fila'); if (fila) fila.classList.toggle('is-on', x.checked); });
      var f = formDe(c); if (f) pintaTotal(f);
      vigila(c);
    });
  }
  function ponCesta(ids) {
    $$('[data-rbe]').forEach(function (c) {
      if (c.getAttribute('data-cesta') === ids) return;
      c.setAttribute('data-cesta', ids);
      ponSet(c, [c.getAttribute('data-o1'), c.getAttribute('data-o2'), c.getAttribute('data-o3')]); ajustaHueco(c);
      var f = formDe(c); if (f) pintaTotal(f);
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', arranca); else arranca();
  // al volver atrás con el navegador la página es la de antes y la cesta puede haber cambiado: se pregunta una vez
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    arranca();
    if ($('[data-rbe-set-datos]')) fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cesta) { ponCesta(',' + (cesta.items || []).map(function (i) { return i.product_id; }).join(',') + ','); }).catch(function () {});
  });
})();
